import {InfoCircleOutlined} from '@ant-design/icons';
import {Flex} from 'antd';
import React from 'react';

const PopupFlex: React.FC<{
  mapData: any;
  isNegative: boolean;
}> = ({mapData, isNegative}) => {
  return (
    <Flex className="popup">
      <div className={`carbonTitle ${isNegative ? 'negative' : 'positive'}`}>
        <div className="infoIcon">
          <InfoCircleOutlined />
        </div>
        <div>{isNegative ? 'Above Benchmark' : 'Below Benchmark'}</div>
      </div>
      <div className="facility">
        <div className="facilityName">{mapData?.name}</div>
        <div className="remark">
          {isNegative ? 'Most Polluted' : 'Pollution in control'}
        </div>
      </div>
      <div className="emission">
        <div className="emissionValue">
          {`${mapData?.emissions?.value} `}
          <span className="emissionValue">{mapData?.emissions?.unit}</span>
        </div>
      </div>
      <div
        className={`emptyDiv ${isNegative ? 'forNegative' : 'forPositive'}`}
      ></div>
    </Flex>
  );
};

export default PopupFlex;
